<div *ngIf="!isEventActive" style="height: 100vh;">
    <router-outlet></router-outlet>
</div>

<div *ngIf="isEventActive" [ngStyle]="checkImage"></div>